import type { FC } from 'react';
import React from 'react';
import { NextSeo } from 'next-seo';

import type { SeoConfig } from '@utils/seo';

type EOSDocsHeadProps = {
  seoConfig: SeoConfig;
};

export const EOSDocsHead: FC<EOSDocsHeadProps> = ({ seoConfig }) => <NextSeo {...seoConfig} />;
